export default {
  namespaced: true,
  state: () => ({
    identifiers: [],
  }),
  getters: {
    isShown: (state) => state.identifiers.length > 0,
  },
  mutations: {
    add(state, payload) {
      state.identifiers.push(payload);
    },
    remove(state, payload) {
      state.identifiers = state.identifiers.filter((i) => i !== payload);
    },
  },
  actions: {},
};
